import { useInitializationDataContext } from './data-context';

export const useDataContext = () => {
  const { initializedDataState } = useInitializationDataContext();
  return { initializedDataState };
};
